import { adminAPIService } from  './index'

const route = 'marketplace'

export default {
  getRefundList() {
    return adminAPIService({
      url: `${route}/orders/refund-reasons`,
      method: 'get',
    })
  },
  createRefundRequest({form, orderId}) {
    const body = `json=${encodeURIComponent(JSON.stringify(form))}`
    return adminAPIService({
      url: `${route}/orders/refund_request/${orderId}`,
      method: 'post',
      data: body,
    })
  },
}